<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        :config-module="controlEventMode ? '231511' : '231510'"
        :reset="true"
        :custom-sim-query-placeholder="$t('CargoMsg.Cargo_CustomerQuickSearch')"
        no="1"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <!--新增-->
          <el-button type="success" no="2" @click="addHandler()">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <!--编辑-->
          <el-button :disabled="!selectedJob || total <= 0" type="primary" no="3" @click="editHandler()">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <!--查看-->
          <el-button :disabled="!selectedJob || total <= 0" type="primary" no="4" @click="viewHandler()">{{ $t('CargoMsg.Cargo_View') }}</el-button>
          <!--打印-->
          <el-button type="primary" no="5" @click="printHandler()">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
          <!--导出Excel-->
          <el-button v-show="$checkPermission(['role_CRMCustomerEventManager_exportExcel'])" type="primary" no="6" @click="btnMenuExcelClickHandler()">{{ $t('CargoMsg.Cargo_ExcelExport') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          config-module="23151000"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          :has-export-role="$checkPermission(['role_CRMCustomerEventManager_exportExcel'])"
          style="width: 100%;"
          no="7"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="23151001"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          no="8"
          @pagination="toQuery()"
        />
      </div>
    </div>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="{}"
      no="9"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />

    <!-- 新增/查看 弹窗 -->
    <el-dialog
      v-if="editDialog.visible"
      id="editDialog"
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('CargoMsg.Cargo_EventRecord')"
      width="700px"
      append-to-body
      no="10"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="justify-content: center;">
        <el-form label-width="100px" label-position="left">
          <el-form-item v-show="editDialog.isEdit && editDialog.state === 1" :label="$t('CargoMsg.Cargo_CustomerChineseName')">
            <cargo-advance-select
              v-show="!controlEventMode"
              filterable
              filter-type="global"
              :default-value="editDialog.form.name"
              :cache="false"
              tag-name="name"
              tag-value="name"
              :filter-tag-names="['name','englishName']"
              style="width:100%"
              options-width="150px;"
              :static-options="editDialog.quotationClientList"
              no="11"
              @parentCallBack="changeHandler"
            />

            <cargo-company-select
              v-show="controlEventMode"
              :method-params="{customer:true, active:true}"
              :check-credit="true"
              :job="editDialog.form"
              :default-value="editDialog.form.cmpIdx||''"
              no="12"
              @change="p=>{changeHandler(p)}"
            />
          </el-form-item>
          <el-form-item v-show="!editDialog.isEdit || editDialog.state === 2" :label="$t('CargoMsg.Cargo_CustomerChineseName')">
            <el-input v-model="editDialog.form.name" :disabled="true" style="width: 100%" no="13" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CustomerEnglishName')">
            <el-input v-model="editDialog.form.englishName" :disabled="true" style="width: 100%" no="14" />
          </el-form-item>
          <div style="display: flex;">
            <el-form-item :label="$t('CargoMsg.Cargo_ClientStatus')" style="width: 50%">
              <el-select
                v-model="editDialog.form.customerStatusCode"
                style="width: 100%"
                :disabled="true"
                :placeholder="$t('CargoMsg.Cargo_PleaseSelectP')"
                size="mini"
                no="15"
              >
                <el-option
                  v-for="(item,index) in CrmCustomerConstants.CUSTOMER_STATUS"
                  :key="index"
                  :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BranchCompany')" style="width: 50%;margin-left: 10px;">
              <el-input v-model="editDialog.form.branchName" :disabled="true" no="16" />
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item :label="$t('CargoMsg.Cargo_theme')" style="width: 50%">
              <el-select
                v-model="editDialog.form.titleName"
                style="width: 100%"
                :disabled="!editDialog.isEdit"
                :placeholder="$t('CargoMsg.Cargo_PleaseSelectP')"
                size="mini"
                no="17"
              >
                <el-option
                  v-for="(item,index) in CrmCustomerConstants.CUSTOMER_EVENT_SUBJECTS"
                  :key="index"
                  :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TaskTime')" style="width: 50%;margin-left: 10px;">
              <el-date-picker
                v-model="editDialog.form.taskTime"
                style="width: 100%;"
                type="datetime"
                :clearable="false"
                format="yyyy-MM-dd HH:mm"
                :disabled="!(editDialog.isEdit && editDialog.isEditTime)"
                :editable="false"
                no="18"
              />
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item :label="$t('CargoMsg.Cargo_Recorder')" style="width: 50%">
              <el-input v-model="editDialog.form.recorderName" :disabled="true" no="19" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_RecordTime')" style="width: 50%;margin-left: 10px;">
              <el-date-picker
                v-model="editDialog.form.recordTime"
                type="datetime"
                style="width: 100%"
                format="yyyy-MM-dd HH:mm"
                :disabled="true"
                no="20"
              />
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item :label="$t('CargoMsg.Cargo_EventStatus')" style="width: 50%">
              <el-select
                v-model="editDialog.form.status"
                style="width: 100%"
                :disabled="!editDialog.isEdit"
                :placeholder="$t('CargoMsg.Cargo_PleaseSelectP')"
                size="mini"
                no="21"
              >
                <el-option
                  v-for="(item,index) in CrmCustomerConstants.CUSTOMER_EVENT_STATUSS"
                  :key="index"
                  :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Location')" style="width: 50%;margin-left: 10px;">
              <el-input v-model="editDialog.form.address" :disabled="!editDialog.isEdit" no="22" />
            </el-form-item>
          </div>
          <el-form-item :label="$t('CargoMsg.Cargo_Participant')">
            <el-input v-model="editDialog.form.participants" :disabled="!editDialog.isEdit" no="23" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ContentDescription')">
            <el-input v-model="editDialog.form.content" type="textarea" :rows="5" :disabled="!editDialog.isEdit" no="24" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Outcomes')">
            <el-input v-model="editDialog.form.achievement" type="textarea" :rows="2" :disabled="!editDialog.isEdit" no="25" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_NextStep')">
            <el-input v-model="editDialog.form.nextTask" type="textarea" :rows="2" :disabled="!editDialog.isEdit" no="26" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ReportTo')">
            <el-input v-model="editDialog.form.reportTarget" type="textarea" :rows="2" :disabled="!editDialog.isEdit" no="27" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
            <el-input v-model="editDialog.form.remarks" type="textarea" :rows="2" :disabled="!editDialog.isEdit" no="28" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_SupervisorComments')">
            <el-input v-model="editDialog.form.supervisorComments" type="textarea" :rows="2" :disabled="!editDialog.isEdit || !editDialog.editSupervisorComments" no="29" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button v-show="editDialog.isEdit" type="primary" no="30" @click="save">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="31" @click="close">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { queryQuotationClientEventPageableFast, queryQuotationClient, saveQuotationClientEvent } from '@/api/sales/quotationClient'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnTagRenderer from '@/components/Cargo/Common/ColumnTagRenderer'
import * as CrmCustomerConstants from '@/class/cargo/model/parameters/CrmCustomerConstants'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import moment from 'moment'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'

export default {
  name: 'EventTreeGrid',
  components: {
    CargoCompanySelect,
    cargoTemplateSelectorDialog,
    cargoUserSelect,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem
  },
  data() {
    return {
      ColumnUtils,
      CrmCustomerConstants,
      selectTypeNames: TYPE_NAMES,
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      isAdvancedQuery: false, // 是否为高级查询
      total: 0,
      selectedJob: null,
      gridParams: {},
      gridOptions: {
        frameworkComponents: {
          ColumnTagRenderer
        },
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        getRowStyle: (params) => {
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        onSortChanged: (event) => {
          // this.$logger.log('onSortChanged-event', event)
          if (this.rowDataBeforeSort.length !== this.rowData.length) {
            this.rowDataBeforeSort = this.rowData
          }
          if (!event.api.getSortModel().length) {
            this.rowData = this.rowDataBeforeSort
            this.rowDataBeforeSort = []
          } else {
            this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
          }
        },
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: event => { this.viewHandler(event.data) }
      },
      columnDefs: [ // 显示列
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerChineseName'),
          field: 'name',
          colId: 'name',
          tooltip: params => params.value,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerEnglishName'),
          field: 'englishName',
          colId: 'englishName',
          tooltip: params => params.value,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ClientStatus'),
          field: 'customerStatusCode',
          colId: 'customerStatusCode',
          valueFormatter: (params) => {
            if (!params.value && params.value !== 0) return ''
            return ColumnUtils.customerStatusCodeToColumnLabelFun(params.value)
          },
          cellRendererSelector: (params) => {
            const render = {
              component: 'ColumnTagRenderer'
            }
            const { customerStatusCode } = params.data
            render.params = {
              color: this.tagColor[customerStatusCode],
              value: ColumnUtils.customerStatusCodeToColumnLabelFun(customerStatusCode)
            }
            return render
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_TaskTime'),
          field: 'taskTime',
          colId: 'taskTime',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Recorder'),
          field: 'recorderId',
          colId: 'recorderId',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_BranchCompany'),
          field: 'branchId',
          colId: 'branchId',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RecordTime'),
          field: 'recordTime',
          colId: 'recordTime',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Location'),
          field: 'address',
          colId: 'address',
          tooltip: params => params.value,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Participant'),
          field: 'participants',
          colId: 'participants',
          tooltip: params => params.value,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_theme'),
          field: 'titleName',
          colId: 'titleName',
          tooltip: (params) => {
            return ColumnUtils.eventTitleCodeToColumnLabelFun(params.value)
          },
          cellRenderer: (params) => {
            return ColumnUtils.eventTitleCodeToColumnLabelFun(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContentDescription'),
          field: 'content',
          colId: 'content',
          tooltip: params => params.value,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Outcomes'),
          field: 'achievement',
          colId: 'achievement',
          tooltip: params => params.value,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_NextTask'),
          field: 'nextTask',
          colId: 'nextTask',
          tooltip: params => params.value,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReportTo'),
          field: 'reportTarget',
          colId: 'reportTarget',
          tooltip: params => params.value,
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          colId: 'remarks',
          tooltip: params => params.value,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SupervisorComments'),
          field: 'supervisorComments',
          colId: 'supervisorComments',
          tooltip: params => params.value,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_EventStatus'),
          field: 'status',
          colId: 'status',
          cellRenderer: (params) => {
            return ColumnUtils.eventStatusCodeToColumnLabelFun(params.value)
          },
          width: 150
        }
      ],
      rowData: [],
      gridApi: null,
      conditions: [],
      tagColor: {
        0: '#8DCE64', // 潜在阶段
        1: '#00A795', // 意向阶段
        2: '#00A6F4', // 商务阶段
        3: '#5469BA' // 合作阶段
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: 'CRM_CUSTOMER_EVENT',
        data: {}
      },
      editDialog: {
        quotationClient: null,
        quotationClientList: [],
        isEditTime: false, // 是否可以编辑时间
        isEdit: false, // 是否编辑状态
        editSupervisorComments: false, // 是否可以编辑主管评论
        visible: false,
        form: {},
        state: 0,
        initialForm: {
          cmpIdx: 0,
          name: '',
          englishName: '',
          customerStatusCode: 0,
          branchId: 0,
          branchName: '',
          uuid: '',
          taskTime: '',
          recorderId: 0,
          recorderName: '',
          address: '',
          participants: '',
          titleName: '',
          status: '',
          content: '',
          recordTime: '',
          remarks: '',
          supervisorComments: '',
          quotationClientUuid: ''
        }
      },
      controlEventMode: false, // 控制事件管理模块服务合作伙伴还是临时客户,默认是临时客户，锦昶家是合作伙伴
      salesEventManager: this.$checkPermission(['role_EventManager_salesEventManager']), // 查看自己事件
      hasDepartmentEventManager: this.$checkPermission(['role_EventManager_departmentEventManager']), // 查看同组事件
      viewAllEventManager: this.$checkPermission(['role_EventManager_viewAllEventManager']) // 查看全部事件
    }
  },
  async created() {
    this.conditions = []
    await cache.load(cacheName.CONFIG)
    this.controlEventMode = Number(cache.config.get('controlEventMode')) === 1
  },
  methods: {
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    async onGridCellFocused(event) {
      if (!event) return
      this.selectedJob = null
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        if (this.gridApi && event.column) {
          this.gridApi.forEachNode(node => {
            if (node && node.rowIndex === event.rowIndex && node.data) {
              const nodeJob = node.data
              if (nodeJob.uuid) this.selectedJob = nodeJob
            }
          })
        }
      })
    },
    // 选中 勾选框触发[获取选中行]
    onGridRowSelected(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      if (event.node.isSelected()) {
        const node = event.data
        if (node.uuid) this.selectedJob = node
      }
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
      })
    },
    onGridReady(p) {
      // console.log('gridReady', p)
      this.gridApi = p.api
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const node = event.data
      if (node.uuid) this.selectedJob = node
    },
    // 查询
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.name = keyword.trim() // 中文名、英文名
        this.filter.pageNum = 1
      }
      const roleMap = {}
      roleMap.name = this.filter.name
      this.conditions = []
      this.queryCommon(roleMap)
    },
    // 高级查询
    toAdvancedQuery(data) {
      if (data) this.conditions = data
      // 高级查询条件组装
      const roleMap = {}
      this.queryCommon(roleMap)
    },
    // 查询公用
    queryCommon(roleMap) {
      if (this.controlEventMode) {
        roleMap.controlEventMode = true // 锦昶专用
      }
      roleMap.activeStatus = true // 是否有效
      roleMap.checkRoleOwner = true
      roleMap.isAdmin = this.$store.getters.isAdmin
      roleMap.approvedState = true // 审核状态
      if (this.salesEventManager) { // 查看自己
        roleMap.viewLevel = 'SALES'
      }
      if (this.hasDepartmentEventManager) { // 查看同组
        roleMap.viewLevel = 'DEPARTMENT'
      }
      if (this.viewAllEventManager) { // 查看所有
        roleMap.viewLevel = 'ALL'
      }
      const requestBody = {
        conditions: this.conditions,
        roleMap,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }
      this.$logger.log('requestBody====', requestBody)
      // 相当于老cargo 的 queryQuotationClientEventPageableFastFast2
      this.loading = getLoading()
      queryQuotationClientEventPageableFast(requestBody).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.total = Number(res.data.total)
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.gridApi.clearFocusedCell()
    },
    // 刷新表格
    refreshAgGrid(runToQuery = false) {
      // 刷新右边查询结果
      if (runToQuery) this.toQuery()
      this.gridApi.refreshCells({ force: true })
      this.gridApi.clearFocusedCell()
    },
    // 新增
    async addHandler() {
      const conMap = {
        ownerId: this.$store.getters.userId,
        branchId: this.$store.getters.currentOfficeId,
        active: true,
        approvedStates: [0, 1]
      }
      const requestBody = { condition: conMap }
      await queryQuotationClient(requestBody).then(res => {
        this.editDialog.quotationClientList = res.data
      })
      this.showEditDialog(1)
    },
    // 编辑
    editHandler() {
      this.showEditDialog(2)
    },
    // 查看
    viewHandler() {
      this.showEditDialog(0)
    },
    // 新增 1 /查看 0
    showEditDialog(state) {
      this.editDialog.isEdit = state !== 0
      this.editDialog.state = state
      if (this.editDialog.isEdit) {
        // 我的客户
        let d = this.$checkPermission(['role_CRMMyGroupCustomerManager_supervisorComments'])
        if (!d) {
          d = this.$checkPermission(['role_TabCRMCustomerEvent_supervisorComments'])
        }
        this.editDialog.editSupervisorComments = d
      }
      if (state === 1) {
        this.editDialog.quotationClient = null
        this.editDialog.isEditTime = true
        this.editDialog.form = { ...this.editDialog.initialForm }
        this.editDialog.form.recorderId = this.$store.getters.userId
        this.editDialog.form.recordTime = new Date()
        this.editDialog.form.taskTime = new Date()
      } else if (state === 0) {
        // 查看 走这里
        if (!this.selectedJob) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PSAEF'))
          return
        }
        this.editDialog.isEditTime = false
        this.editDialog.form = this.selectedJob
        this.editDialog.form.customerStatusCode = parseInt(this.selectedJob.customerStatusCode)
        if (this.editDialog.form.branchId) {
          const office = getObjectByCache(basicCacheKeys.basic_data_Office, 'officeId', parseInt(this.editDialog.form.branchId))
          this.editDialog.form.branchName = office ? (this.$store.getters.language === 'zh' ? office.chineseName : office.englishName) : ''
        }
      } else {
        // 编辑 走这里
        if (!this.selectedJob) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PSAEF'))
          return
        }
        this.editDialog.isEditTime = false
        this.editDialog.form = this.selectedJob
        this.editDialog.form.customerStatusCode = parseInt(this.selectedJob.customerStatusCode)
        if (this.editDialog.form.branchId) {
          const office = getObjectByCache(basicCacheKeys.basic_data_Office, 'officeId', parseInt(this.editDialog.form.branchId))
          this.editDialog.form.branchName = office ? (this.$store.getters.language === 'zh' ? office.chineseName : office.englishName) : ''
        }
      }
      const user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', parseInt(this.editDialog.form.recorderId))
      this.editDialog.form.recorderName = this.$store.getters.language === 'zh' ? user.chineseName : user.englishName
      this.editDialog.visible = true
    },
    // 确认保存
    async save() {
      if (!this.editDialog.form.name) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ChineseNameCanTBeEmpty'))
        return
      }
      if (!this.editDialog.form.titleName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectSubject'))
        return
      }
      if (!this.editDialog.form.status) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectEventStatus'))
        return
      }
      if (!this.editDialog.form.quotationClientUuid) this.editDialog.form.quotationClientUuid = this.editDialog.quotationClient.uuid
      this.loading = getLoading()
      await saveQuotationClientEvent(this.editDialog.form).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.toQuery()
      }).finally(() => {
        this.loading.close()
        this.close()
      })
    },
    // 客户中文名改变事件
    changeHandler(obj) {
      if (!obj || !obj.uuid) {
        this.editDialog.form.customerStatusCode = this.controlEventMode ? 3 : 0
        this.editDialog.form.branchId = 0
        this.editDialog.form.branchName = ''
        this.editDialog.form.name = ''
        this.editDialog.form.englishName = ''
        this.editDialog.quotationClient = null
        return
      }
      if (obj.branchId) {
        const office = getObjectByCache(basicCacheKeys.basic_data_Office, 'officeId', parseInt(obj.branchId))
        this.editDialog.form.branchName = office ? (this.$store.getters.language === 'zh' ? office.chineseName : office.englishName) : ''
      }
      if (this.controlEventMode) {
        this.editDialog.form.customerStatusCode = 3
        this.editDialog.form.name = obj.chineseName
      } else {
        this.editDialog.form.customerStatusCode = parseInt(obj.customerStatusCode)
        this.editDialog.form.name = obj.name
      }
      this.editDialog.form.englishName = obj.englishName
      this.editDialog.form.quotationClientUuid = obj.uuid
      this.editDialog.quotationClient = obj
    },
    // 取消
    close() {
      this.editDialog.visible = false
    },
    // 打印
    printHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ClientEventNotSelected'))
        return
      }
      const listKeys = Array.from(rows, p => p.uuid)
      const params = { CRM_CUSTOMER_EVENT_UUID: listKeys }
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.category = 'CRM_CUSTOMER_EVENT'
      this.templateSelectorDialog.visible = true
    },
    // 导出
    btnMenuExcelClickHandler() {
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      // 获取选中行
      const rows = this.gridApi.getSelectedRows()
      if (rows && rows.length > 0) {
        exportExcel(`CustomerEvent_${moment().format('YYYYMMDDkkmmss')}`, rows, allDisplayedColumns)
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectRecordsToExport'))
      }
    }
  }
}
</script>
<style scoped lang="scss">
#editDialog .app-main-inner-row ::v-deep {
 .el-form-item__label {
   font-size: 12px;
   font-weight: normal;
 }
}
</style>
